<template>
  <div class="name-cell">
    <c-button
      v-if="record.isWorker"
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: 'Клиент отмечен как сотрудник',
        placement: 'top',
      }"
      size="iconic"
      icon="employee"
    />
    <div :class="{ 'name-cell-client-name-worker': record.isWorker }" class="name-cell-client-name">
      {{ record.name.value }}
    </div>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";

export default {
  name: "name-cell",
  components: {
    "c-button": Button,
  },
  props: ["record"],
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.name-cell {
  line-height: 13px;
  font-size: 13px;
  padding: 10px !important;
  -webkit-transition: font 0.3s ease;
  transition: font 0.3s ease;
  display: flex;
  align-items: center;

  &-client-name {
    margin-left: 25px;

    &-worker {
      margin-left: 5px;
    }
  }
}
</style>
